import * as z from "zod";

export const MAX_CLAIM_DOCUMENT_REQUEST_DESCRIPTION_LENGTH = 2000;
export const MAX_CLAIM_DOCUMENT_REQUEST_SUBJECT_LENGTH = 150;

export function defaultClaimDocumentRequestSubject(storeName: string): string {
  return `Action needed: your ${storeName} claim`;
}

export const requestAdditionalClaimDocuments = {
  name: "requestAdditionalClaimDocuments" as const,
  input: z.object({
    returnId: z.string(),
    description: z
      .string()
      .trim()
      .min(1)
      .max(MAX_CLAIM_DOCUMENT_REQUEST_DESCRIPTION_LENGTH),
    /** Overrides the return's customer email as the notification recipient. */
    recipientEmail: z.string().trim().email().optional(),
    /** Overrides the default email subject. */
    subject: z
      .string()
      .trim()
      .min(1)
      .max(MAX_CLAIM_DOCUMENT_REQUEST_SUBJECT_LENGTH)
      .regex(/^[^\r\n]*$/, "Subject must be a single line")
      .optional(),
  }),
  output: z.null(),
};
